'use strict';

var AppState = require('app_state');
var AbstractFormView = require('components/common/views/abstract_form_view');
var i18n = require('utils/i18n');
var Messages = require('utils/messages');
var Requests = require('utils/requests');

var LoginView = AbstractFormView.extend({
    template: require('components/account/templates/login'),

    events: {
        'click button.js-login': 'loginClicked',
        'click span.js-lang': 'languageClicked',
        'click a#js-terms': 'termsClicked',
        'click a#js-gdpr': 'gdprClicked',
        'click a#js-imprint': 'imprintClicked',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.contextData = options.contextData;

        AbstractFormView.prototype.initialize.apply(this, [
            {
                inputFields: {
                    'js-email': {},
                    'js-password': {},
                },
                errors: options.errors,
                formData: options.formData,
            },
        ]);

        this.openIDProvider = [];
        _.each(
            AppState.openIDProvider,
            function (provider) {
                this.openIDProvider.push({
                    type: provider.type,
                    name: provider.text,
                    link: window.location.origin + '/api/v1/account/openid/login/' + provider.type,
                });
            },
            this
        );
    },

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);
        if (this.contextData && this.contextData.info) {
            data.info = this.contextData.info;
        }

        data.lang = i18n.language.toUpperCase();
        data.isSubdomain = AppState.isSubdomain;
        data.message = AppState.message;
        data.openIDProvider = this.openIDProvider;

        return data;
    },

    loginClicked: function (e) {
        e.preventDefault();
        if (this.allFieldsValid()) {
            var loginData = Backbone.Syphon.serialize(this);
            this.setActivation(loginData);
            this.controller.authenticate(loginData);
        }
    },

    setActivation: function (loginData) {
        if (this.options.contextData && this.options.contextData.activation) {
            var ctxActivation = this.options.contextData.activation;

            loginData.activationType = ctxActivation.type;
            loginData.activationToken = ctxActivation.token;
        }
    },

    languageClicked: function (e) {
        var self = this;
        i18n.languageClicked(e, function () {
            var messageInit = Messages.initialize();
            $.when(messageInit).done(function () {
                self.render();
            });
        });
    },

    termsClicked: function (e) {
        e.preventDefault();
        this.controller.showTermsDialog();
    },

    gdprClicked: function (e) {
        e.preventDefault();
        this.controller.showGdprDialog();
    },

    imprintClicked: function (e) {
        e.preventDefault();
        this.controller.showImprint();
    },

    onAttach: function () {
        $('[data-toggle="popover"]').popover();

        var subdomain = Requests.getSubdomain(window.location.host) || 'samson';
        $('.account-pages').css('background-image', 'url(../img/backgrounds/' + subdomain + '.jpg)');
    },

    onRender: function () {
        this.onAttach();
    },
});

module.exports = LoginView;
